import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, DescriptiveText, LoadingSpinner, Page, Tile} from '../../../../../shared';
import {withRouter} from 'react-router-dom';
import axiosInstance from '../../../../../shared/utils/axios';
import {openNewTab} from '../../../../utils/partners';
import history from '../../../../../history';
import {isAuthorized} from '../../../../../shared/reducers/user';
import {_openModal} from '../../../../../shared/reducers/modals';
import useQueryString from '../../../../../shared/utils/useQueryString';

const SalesforceFSSSO = (props) => {
  const {session, openModal} = props;
  const [processing, setProcessing] = useState(true);
  const [accountID] = useQueryString('accountID');
  const [householdID] = useQueryString('householdID');
  const [clientID] = useQueryString('clientID');

  useEffect(() => {
    if (!session.profile.sfsID) {
      return;
    }
    const params = [
      ['accountID', accountID],
      ['householdID', householdID],
      ['clientID', clientID],
    ].filter(o => !!o[1]);

    axiosInstance.get(`/advisors/${session.profile.id}/sfs/login?${new URLSearchParams(params)}`)
      .then(res => {
        setProcessing(false);
        openNewTab(res.data);
      })
      .catch(err => openModal({type: 'Error', err}));
  }, []);

  return <Page>
    <Tile key={'Connecting to Salesforce...'} title={'Connecting to Salesforce...'}>
      {processing
        ? <LoadingSpinner/>
        : <DescriptiveText>
          A new tab will open directly to your Salesforce Financial Services Cloud.
          If it does not, please check your popup blocker.
          {isAuthorized(['FIRMMGR'])
          && <Button importance={'primary'}
                     size={'md'}
                     label={'Firm Configuration'}
                     action={() => history.push('/engage/sfs/firmConfigure')}/>}
        </DescriptiveText>}
    </Tile>

  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SalesforceFSSSO));

SalesforceFSSSO.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
  /**
   * Is from Modals Reducer
   */
  openModal: PropTypes.func.isRequired,
};
